// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see SplitRequestEditAmountEvent
 */
export var SplitRequestEditAmount = function (_a) {
    var amount = _a.amount, contactStatus = _a.contactStatus, externalId = _a.externalId, recipientId = _a.recipientId;
    return ({
        name: "Split Request EditAmount",
        parameters: {
            cdf_entity: "Split",
            cdf_action: "Request",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            contact_status: contactStatus !== undefined && contactStatus !== null ? contactStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_id: recipientId !== undefined && recipientId !== null ? recipientId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SplitRequestErrorEvent
 */
export var SplitRequestError = function (_a) {
    var errorMessage = _a.errorMessage, externalId = _a.externalId, retryable = _a.retryable;
    return ({
        name: "Split Request Error",
        parameters: {
            cdf_entity: "Split",
            cdf_action: "Request",
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            retryable: retryable !== undefined && retryable !== null ? retryable.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SplitRequestResetConfigEvent
 */
export var SplitRequestResetConfig = function (_a) {
    var externalId = _a.externalId;
    return ({
        name: "Split Request ResetConfig",
        parameters: {
            cdf_entity: "Split",
            cdf_action: "Request",
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SplitRequestStartEvent
 */
export var SplitRequestStart = function (_a) {
    var amount = _a.amount, externalId = _a.externalId, includeYourself = _a.includeYourself, recipientCount = _a.recipientCount;
    return ({
        name: "Split Request Start",
        parameters: {
            cdf_entity: "Split",
            cdf_action: "Request",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            include_yourself: includeYourself !== undefined && includeYourself !== null ? includeYourself.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_count: recipientCount !== undefined && recipientCount !== null ? recipientCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SplitRequestSubmitEvent
 */
export var SplitRequestSubmit = function (_a) {
    var externalId = _a.externalId, includeYourself = _a.includeYourself, recipientCount = _a.recipientCount;
    return ({
        name: "Split Request Submit",
        parameters: {
            cdf_entity: "Split",
            cdf_action: "Request",
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            include_yourself: includeYourself !== undefined && includeYourself !== null ? includeYourself.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_count: recipientCount !== undefined && recipientCount !== null ? recipientCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SplitRequestToggleIncludeYourselfEvent
 */
export var SplitRequestToggleIncludeYourself = function (_a) {
    var enabled = _a.enabled, externalId = _a.externalId;
    return ({
        name: "Split Request ToggleIncludeYourself",
        parameters: {
            cdf_entity: "Split",
            cdf_action: "Request",
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SplitRequestUpdateAmountEvent
 */
export var SplitRequestUpdateAmount = function (_a) {
    var amount = _a.amount, externalId = _a.externalId, recipientId = _a.recipientId;
    return ({
        name: "Split Request UpdateAmount",
        parameters: {
            cdf_entity: "Split",
            cdf_action: "Request",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_id: recipientId !== undefined && recipientId !== null ? recipientId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
